module.exports = __webpack_public_path__ + "files/SPIADI2022 - Rapport national CLEANHAND4.3b967095c9895de75bd3ba3c76d3f735.pdf";